export default {
  // Hero section
  'hero.title': 'پیشہ ورانہ آن لائن ٹائمر ٹولز',
  'hero.subtitle': 'اپنی ضروریات کے لیے بہترین ٹائمنگ ٹول منتخب کریں',

  // Tool cards
  'timer.title': 'ٹائمر',
  'timer.description': 'کام، مطالعہ اور زندگی کے لیے الٹی گنتی ٹائمر',
  'timer.longDescription': 'پیداواری صلاحیت، کھانا پکانے اور وقت کے انتظام کے لیے الٹی گنتی ٹائمر',
  'timer.button': 'ٹائمر شروع کریں',

  'stopwatch.title': 'سٹاپ واچ',
  'stopwatch.description': 'اعلیٰ درستگی ٹائمنگ ٹول',
  'stopwatch.longDescription': 'کھیلوں، تربیت اور درست ٹائمنگ کے لیے اعلیٰ درستگی سٹاپ واچ',
  'stopwatch.button': 'سٹاپ واچ شروع کریں',

  'worldclock.title': 'عالمی گھڑی',
  'worldclock.description': 'دنیا بھر میں ٹائم زون دیکھیں',
  'worldclock.longDescription': 'ذہین ٹائم زون حساب کتاب کے ساتھ عالمی بڑے شہروں کے اوقات کی حقیقی وقت میں نمائش',
  'worldclock.button': 'عالمی گھڑی دیکھیں',

  // Features section
  'features.title': 'timer.today کیوں منتخب کریں؟',
  'features.reliable.title': 'قابل اعتماد اور درست',
  'features.reliable.desc': 'براؤزر پر مبنی قابل اعتمادی کے ساتھ ملی سیکنڈ کی درستگی ٹائمنگ',
  'features.crossPlatform.title': 'کراس پلیٹ فارم',
  'features.crossPlatform.desc': 'ڈیسک ٹاپ، ٹیبلیٹ اور موبائل آلات پر بغیر کسی رکاوٹ کے کام کرتا ہے',
  'features.smartNotifications.title': 'ذہین اطلاعات',
  'features.smartNotifications.desc': 'وقت ختم ہونے پر آواز کی انتباہات اور ڈیسک ٹاپ اطلاعات',
  'features.easyToUse.title': 'استعمال میں آسان',
  'features.easyToUse.desc': 'تمام صارفین کے لیے بدیہی کنٹرولز کے ساتھ صاف انٹرفیس',

  // Keywords section
  'keywords.timer': 'ٹائمر الٹی گنتی پوموڈورو فوکس کام وقفہ',
  'keywords.chinese': '计时器 倒计时 番茄钟 专注 休息',
  'keywords.japanese': 'タイマー カウントダウン ポモドーロ 集中 休憩',
  'keywords.spanish': 'temporizador cuenta regresiva pomodoro concentración',
  'keywords.german': 'Timer Countdown Pomodoro Konzentration Pause',
  'keywords.french': 'minuteur compte à rebours pomodoro concentration',
  'keywords.russian': 'таймер обратный отсчет помодоро концентрация',
};
